import backend, {JOB_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const createJob = (job) => {
  const url = `${JOB_API}/career/job`;
  return backend.post(url, job);
};

const getJob = async (jobRn, loadApplicants = true, loadClient) => {
  const queryParam = {
    loadApplicants: loadApplicants,
    loadClient: loadClient,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${JOB_API}/career/job/${jobRn}?${query}`;
  return backend.get(url);
};

const queryJob = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }
  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }

  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${JOB_API}/career/job?${query}`;
  return backend.get(url);
};

const updateJobStatus = (jobRn, status) => {
  const url = `${JOB_API}/career/job/${jobRn}`;
  return backend.put(url, status);
};

const updateJobPriority = (jobRn, priority) => {
  const url = `${JOB_API}/career/job/${jobRn}/priority`;
  return backend.put(url, priority);
};

const updateJob = (jobRn, job) => {
  const url = `${JOB_API}/career/job/${jobRn}/update`;
  return backend.put(url, job);
};

const updateApplicationStatus = (jobRn, caregiverRn, status) => {
  const url = `${JOB_API}/career/job/${jobRn}/application/${caregiverRn}`;
  const body = {
    status: status,
  };
  return backend.put(url, body);
};

const createMessage = (jobRn, input) => {
  const url = `${JOB_API}/career/job/${jobRn}/message`;
  return backend.post(url, input);
};

const updateMessage = (jobRn, messageRn, input) => {
  const url = `${JOB_API}/career/job/${jobRn}/message/${messageRn}`;
  return backend.put(url, input);
};

const addEmoji = (jobRn, messageRn, input) => {
  const url = `${JOB_API}/career/job/${jobRn}/message/${messageRn}/emoji`;
  return backend.put(url, input);
};

const removeEmoji = (jobRn, messageRn, input) => {
  const url = `${JOB_API}/career/job/${jobRn}/message/${messageRn}/emoji`;
  return backend.delete(url, input);
};

const removeMessage = (jobRn, messageRn) => {
  const url = `${JOB_API}/career/job/${jobRn}/message/${messageRn}`;
  return backend.delete(url);
};

const loadMoreMessages = (jobRn, lastKey, loadSubmittedByData, loadEmojiRequesters) => {
  const queryParam = {
    lastEvaluatedKey: lastKey,
    loadSubmittedByData,
    loadEmojiRequesters,
  };

  const query = queryString.stringify(queryParam, {
    skipNull: true,
    skipEmptyString: true,
    encode: true,
  });

  return backend.get(`${JOB_API}/career/job/${jobRn}/message?${query}`);
};

export default {
  createJob,
  getJob,
  queryJob,
  updateJob,

  updateJobStatus,
  updateJobPriority,
  updateApplicationStatus,

  message: {
    create: createMessage,
    update: updateMessage,
    delete: removeMessage,
    load: loadMoreMessages,

    emoji: {
      add: addEmoji,
      remove: removeEmoji,
    },
  },
};
